<script setup>
import { computed } from 'vue';
import Available from '@components/OfferCard/labels/Available.vue';
import Contacted from '@components/OfferCard/labels/Contacted.vue';
import ProposalOffmarket from '@components/OfferCard/labels/ProposalOffmarket.vue';
import Rent from '@components/OfferCard/labels/Rent.vue';
import State from '@components/OfferCard/labels/State.vue';
import { isOfferDisabled } from '@organisms/offer/offer-utils';

const props = defineProps({
  offer: {
    type: Object,
    required: true,
  },
  proposal: {
    type: Object,
    default: null,
  },
  isOwnerView: {
    type: Boolean,
    default: false,
  },
  isContacted: {
    type: Boolean,
    default: false,
  },
});

const isRented = computed(() => {
  if (props.proposal) {
    return props.proposal.is_all_offers_rented;
  }

  return isOfferDisabled(props.offer);
});
</script>

<template>
  <div class="hit-labels image">
    <template v-if="isOwnerView">
      <State :offer="offer" />
    </template>
    <template v-else>
      <Available :offer="offer" />
      <Contacted v-if="isContacted" />
      <Rent :is-rented="isRented" />
      <template v-if="proposal">
        <ProposalOffmarket :offer="offer" />
      </template>
    </template>
  </div>
</template>
